import { render, staticRenderFns } from "./Portions.vue?vue&type=template&id=670efa76&"
import script from "./Portions.vue?vue&type=script&lang=ts&"
export * from "./Portions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports